export default __webpack_public_path__ + "static/media/accessories.ca0fe1e3.jpg";